<template>
	<div>
	  <el-drawer
		  title="广告编辑修改"
		  size="80%"
		  custom-class="ads_edit"
		  :visible.sync="AdsEditDrawer"
		  :before-close="handleClose"
		  direction="btt">
		    <el-row style="padding:0px 20px;">
				<el-tabs v-model="activeName">
					<el-tab-pane label="广告计划" name="AdsEditPanel">
					  <EditPanelAds @updateAds="updateAds" :AdsForm.sync="AdsForm" @cancelAdsEditDrawer="cancelAdsEditDrawer"></EditPanelAds>
					</el-tab-pane>
					<el-tab-pane label="广告创意" name="CreativeEditPanel">
					 <CreativeEditPanel @updateAds="updateAds" @cancelAdsEditDrawer="cancelAdsEditDrawer" :AdsForm.sync="AdsForm" ref="creativeBody"></CreativeEditPanel>
					</el-tab-pane>
				</el-tabs>
			</el-row>
		</el-drawer>
	</div>
</template>

<script>
	import EditPanelAds from './ads.vue'
	import CreativeEditPanel from './creative.vue'
	
	export default {
		components: {EditPanelAds,CreativeEditPanel},
		props:{		 
		},
		data() {
			return {
				activeName:'AdsEditPanel',
				AdsForm:{},
				AdsEditDrawer:false
			}
		},
		watch: {
		  activeName(val) {
			if(val=='CreativeEditPanel')
			{
			  this.$refs.creativeBody.getCreative()
			}
		  }
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   }
		},
		methods: {		  			
			openEditDrawer(row){			 
			 this.AdsEditDrawer = true
             let version = row.app_type=='APP_IOS'?row.audience.ios_osv:row.audience.android_osv
             let ad_tag = row.audience.ad_tag.length==0?'-1':(row.audience.ad_tag.length==1 && row.audience.ad_tag[0]==0)?'-2':row.audience.ad_tag		 
             this.AdsForm = Object.assign({version:version,ad_tag:ad_tag},row)			 
			},
			handleClose(){
			  this.AdsEditDrawer =false
			  this.activeName = 'AdsEditPanel'
			},
			updateAds(){
			 this.$emit("getAds")
			},
			cancelAdsEditDrawer(){
			  this.AdsEditDrawer = false
			}
		},
		mounted() {	
		}
	}

</script>
<style  lang="scss">
.ads_edit{max-height:500px;overflow-y:auto;}
</style>


// WEBPACK FOOTER //
// index.vue?04fa0f69